<div class="progressContainer">
    <p-progressBar mode="indeterminate" *ngIf="isLoading$ | async"></p-progressBar>
</div>
<div class="row full-height full-width" style="position: relative;">
    <div class="column full-height full-width">
        <div class="main-header" *ngIf="currentPageTitle">
            <img src="assets/images/heaer_bg.svg" class="desktop" />
            <img src="assets/images/heaer_bg.png" class="mobile" />
            <span class="header-text">{{currentPageTitle}}</span>
            <div class="row">
                <span class="fixed-logo mobile" [routerLink]="''"></span>
            </div>
        </div>
        <div class="layout-content" [ngClass]="{'with-header':currentPageTitle}">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-side-menu class="full-height"></app-side-menu>
</div>